import { createAction, props } from '@ngrx/store';
import { FlightSearchConfig } from '../../flight-search-v2/models/flight-search-config.model';
import { FlightSearchForm } from '../../flight-search-v2/models/flight-search-form.model';
import { FlightSearchType } from '../../flight-search-v2/enums/flight-search-type.enum';
import { FlightData } from '../../flight-search-v2/models/flight-data.model';
import { FlightSearchResults } from '../../flight-search-v2/models/flight-search-results.model';
import { MenuListItem } from '@atpco/hub-ui';

export const FlightSearch_UpdateConfig = createAction(
  '[FS2] Set flight search configuration',
  props<{ config: Partial<FlightSearchConfig> }>()
);

export const FlightSearch_ToggleFormReset = createAction(
  '[FS2] Toggle form reset flag',
  props<{ resetSearchForms: boolean }>()
);

export const FlightSearch_ToggleFormValidation = createAction(
  '[FS2] Toggle form validation flag',
  props<{ validateSearchForms: boolean }>()
);

export const FlightSearch_ResetSearchForms = createAction(
  '[FS2] Reset search forms',
);

export const FlightSearch_SetFlightSearchForm = createAction(
  '[FS2] Set values for flight search form',
  props<{ formData: FlightSearchForm}>()
);

export const FlightSearch_SetFlightSearchFormOutbound = createAction(
  '[FS2] Set flight search form outbound segments',
  props<{ formData: FlightSearchForm}>()
);

export const FlightSearch_SetSearchType = createAction(
  '[FS2] Set search type',
  props<{ searchType: FlightSearchType }>()
);


export const FlightSearch_ResetSearchRequestConfig = createAction(
  '[FS2] Reset search request config',
);

export const FlightSearch_ResetSearchResults = createAction(
  '[FS2] Reset search results',
);

export const FlightSearch_StartSearch = createAction(
  '[FS2] Start search',
);

export const FlightSearch_SearchRequest = createAction(
  '[FS2] Search request',
  props<{ params: any, searchType: FlightSearchType }>()
);

export const FlightSearch_SearchResponse = createAction(
  '[FS2] Search response',
  props<{ response: any, searchType: FlightSearchType }>()
);

export const FlightSearch_AddSelectedFlight = createAction(
  '[FS2] Add selected flight',
  props<{ flightData: FlightData, cabin: string}>()
);

export const FlightSearch_ChangeSelectedFlight = createAction(
  '[FS2] Change selected flight',
  props<{ flightNumber: number | null }>()
);

export const FlightSearch_ClearRemainingSelectedFlights = createAction(
  '[FS2] Clear remaining selected flight',
  props<{ changedFlightIndex: number }>()
);

export const FlightSearch_UpdateRouteHappyApiData = createAction(
  '[FS2] Update Route Happy API data',
  props<{ params: FlightSearchForm, response: FlightSearchResults }>()
);

export const FlightSearch_SetRouteHappyApiData = createAction(
  '[FS2] Set Route Happy API data',
  props<{ apiRequests: string[], apiResponse: string }>()
);
